module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "the-blessing-prayer"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('div', {
    staticClass: "image2"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "Envelope.tif",
      "src": "images/Envelope_fmt.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ital-cntr"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Above is a scan of the battered manila envelope that this manuscript was found in.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "anchor-anchor"
    }
  }, [_c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The Blessing Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("In the name of Dryghtyn, the Ancient Providence, "), _c('br'), _vm._v("which was from the beginning and is for eternity "), _c('br'), _vm._v("male and female, the original source of all things: "), _c('br'), _vm._v("all-knowing, all-pervading, all-powerful, changeless, "), _c('br'), _vm._v("eternal; in the names of the Lady of the Moon "), _c('br'), _vm._v("and our Lord the Horned One; in the names of the Spirits "), _c('br'), _vm._v("of the Stones, rulers of the elemental realms: "), _c('br'), _vm._v("Bless this place, and this time, and they who are "), _c('br'), _vm._v("with us.*")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("(to be said before every rite, just after building the Circle of Stones)")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("* Scott Cunningham had a second version of this blessing prayer, in which he added deity names: “the Lady of the Moon, Diana, and our Lord the Horned One, Kernunnos.”")])])]), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "anchor-anchor"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  })]), _c('a', {
    attrs: {
      "href": "#/Contents#x-contents-anchor"
    }
  }, [_vm._v("[contents]")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-796c3ca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/The_Blessing_Prayer.vue
// module id = 72
// module chunks = 0